import { blue, grey } from '../colors';

export const dataGridThemeOptions = {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
        },
        columnHeader: {
          padding: '16px',
          '&:focus': { outline: 'none' },
          '&:focus-within': { outline: 'none' },
          '&.MuiDataGrid-columnHeaderCheckbox': {
            padding: '0 !important',
          },
        },
        columnHeaders: {
          backgroundColor: `${grey[50]}`,
          borderRadius: 0,
          boxShadow: 'inset 0px -1px 0px hsla(0, 0%, 0%, 0.08)',
        },
        columnSeparator: {
          visibility: 'hidden',
        },
        cell: {
          padding: '16px',
          boxShadow: 'inset 0px -1px 0px hsla(0, 0%, 93%, 1)',
          '&:focus': { outline: 'none' },
          '&:focus-within': { outline: 'none' },
          borderBottom: 'none',
        },
        row: {
          borderRadius: '4px',
          border: '1px solid transparent',
          '&.Mui-selected': { border: `1px solid ${blue[500]}` },
          '&:hover': { backgroundColor: 'hsla(211, 100%, 45%, 0.04)' },
        },
      },
    },
  },
};
